module.exports = __webpack_public_path__ + "img/Apple TV.1ea67939.jpg";